import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { IntegrationService } from '../../shared/services/integration.service';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { DraftCommonWire } from '../models/wire/WireTemplatesResponse';
import { JsonApiWrap } from '../../shared/models/JsonApiWrap';
import { WireTemplatesRequest } from '../models/wire/WireTemplatesRequest';

@Injectable({
  providedIn: 'root',
})
export class DraftsService {
  constructor(
    private headersService: HeadersService,
    private baseService: BaseRestService,
    private integrationService: IntegrationService
  ) { }

  mmExperienceApiPath: string = 'api/ria.MoneyMovementExperience';

  callWireTemplatesGetList(accountId: string): Observable<DraftCommonWire[]> {
    const url =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      `/v1/Drafts?${encodeURIComponent('filter[status]')}=${encodeURIComponent(
        'template'
      )}`;
    const headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    headers['Schwab-Client-Ids'] = `Sub=${accountId} `;

    return this.baseService.requestJsonApiList(url, headers, null, 'GET');
  }

  callWirePatchTemplate(
    requestData: WireTemplatesRequest
  ): Observable<DraftCommonWire> {
    let serviceUrl =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      `/v1/WireTemplate/${requestData.draftId}`;

    let requestBody: JsonApiWrap<WireTemplatesRequest> = {
      data: {
        type: 'common-draft',
        id: '',
        attributes: requestData,
      },
    };
    let headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    return this.baseService.request<WireTemplatesRequest, DraftCommonWire>(
      serviceUrl,
      headers,
      requestBody,
      'PATCH',
      false
    );
  }

  callWireCreateTemplate(
    requestData: WireTemplatesRequest
  ): Observable<DraftCommonWire> {
    let serviceUrl =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      '/v1/WireTemplate';
    let requestBody: JsonApiWrap<WireTemplatesRequest> = {
      data: {
        type: 'common-draft',
        id: '',
        attributes: requestData,
      },
    };
    let headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');

    return this.baseService.post<WireTemplatesRequest, DraftCommonWire>(
      serviceUrl,
      headers,
      requestBody,
      true
    );
  }

  callDeleteTemplate(draftId: string | undefined): Observable<DraftCommonWire[]> {
    const url =
      this.integrationService.JfkEnv.BaseUrl +
      this.mmExperienceApiPath +
      `/v1/WireTemplate/${draftId}`;
    const headers =
      this.headersService.createHeadersWithJsonApiContentSharedToken('1');

    return this.baseService.request(url, headers, null, 'DELETE', true);
  }

  callDeleteInitiatedDraft(draftId: string): Observable<null>{
    const url = this.integrationService.JfkEnv.BaseUrl + this.mmExperienceApiPath + `/v1/Drafts/${draftId}`;
    const headers = this.headersService.createHeadersWithJsonApiContentSharedToken('1');
    return this.baseService.request(url, headers, null, 'DELETE', false);
  }
}
